import { ForwardIcon, XMarkIcon } from '@heroicons/react/24/outline';
import { ConfirmLayout } from './ConfirmLayout';
import { DmButton } from './DmControlPrimitives';

interface AlignerChangeStepProps {
    patientName?: string;
    /** A forced change is pending, so this step withdraws it. */
    pending: boolean;
    busy: boolean;
    error: string | null;
    onConfirm: () => void;
    onCancel: () => void;
}

export function AlignerChangeStep({
    patientName,
    pending,
    busy,
    error,
    onConfirm,
    onCancel
}: AlignerChangeStepProps) {
    const who = patientName ?? 'the patient';
    const confirmLabel = pending
        ? busy
            ? 'Cancelling…'
            : 'Cancel pending change'
        : busy
          ? 'Forcing…'
          : 'Force aligner change';
    return (
        <ConfirmLayout
            error={error}
            cancel={
                <DmButton onClick={onCancel} disabled={busy}>
                    {pending ? 'Keep it' : 'Cancel'}
                </DmButton>
            }
            confirm={
                <DmButton
                    kind={pending ? 'warning' : 'start'}
                    icon={pending ? XMarkIcon : ForwardIcon}
                    disabled={busy}
                    loading={busy}
                    onClick={onConfirm}
                >
                    {confirmLabel}
                </DmButton>
            }
        >
            <div className="space-y-1">
                <p className="text-sm font-semibold text-gray-800">
                    {pending
                        ? 'Cancel the pending aligner change?'
                        : 'Force the next aligner change?'}
                </p>
                <p className="text-xs text-gray-500">
                    {pending
                        ? 'Withdraw the pending instruction to switch to the next aligner.'
                        : `Tell ${who} to switch to their next aligner now.`}
                </p>
            </div>
        </ConfirmLayout>
    );
}
